export default __webpack_public_path__ + "d4cc8d24d0d476e869435e5f7a12b7ed.png";